import Typography from '@mui/material/Typography';
import Box from '@mui/system/Box';
import { Game } from '../../../functions/src/types/firestore/Game';
import { GamePlatforms } from './GamePlatforms';

type GameTitleProps = Pick<Game, 'title' | 'platforms'>;

export function GameTitle({ title, platforms }: GameTitleProps) {
  return (
    <Box
      display={'flex'}
      flexDirection={'row'}
      alignItems={'center'}
      flexWrap={'wrap'}
    >
      <Box mr={8}>
        <Typography variant="h3">{title}</Typography>
      </Box>
      {platforms && (
        <Box
          flexGrow={1}
          pt={2.5}
          pb={1}
          display={'flex'}
          alignItems={'center'}
        >
          <GamePlatforms
            typographyVariant="h4"
            supportedPlatforms={platforms}
          />
        </Box>
      )}
    </Box>
  );
}
